export default class Event {
	constructor({
		id,
		activity_id,
		init_date,
		end_date,
		init_hour,
		end_hour,
		repeat,
		resource_id,
		visit_point_id,
		additional_info,
		event_status_id,
		event_status_name,
		date_prog,
		// data from server
		activity_name,
		address,
		city,
		company_id,
		country,
		cx,
		cy,
		department,
		on_demand,
		schedule_wp_id,
		username,
		visit_point_identification,
		visit_point_name,
		schedule_follwers_id,
	}) {
		this.activity_id = activity_id || 0;
		this.init_date = init_date || "";
		this.end_date = end_date || "";
		this.init_hour = init_hour || "";
		this.end_hour = end_hour || "";
		this.repeat = repeat || "";
		this.resource_id = resource_id || 0;
		this.visit_point_id = visit_point_id || 0;
		this.additional_info = additional_info ? additional_info : {};
		this.event_status_id = event_status_id || 2;
		this.event_status_name = event_status_name || "";
		this.id = id || 0;

		this.date_prog = date_prog || "";

		// data from server
		this.activity_name = activity_name || "";
		this.address = address || "";
		this.city = city || "";
		this.company_id = company_id || 0;
		this.country = country || "";
		this.cx = cx || "";
		this.cy = cy || "";
		this.department = department || "";
		this.on_demand = on_demand || false;
		this.schedule_wp_id = schedule_wp_id || 0;
		this.username = username || "";
		this.visit_point_identification = visit_point_identification || "";
		this.visit_point_name = visit_point_name || "";
		this.schedule_follwers_id = schedule_follwers_id || [];
	}

	setAddtionalInfo(dataFields) {
		this.additional_info = {};
		const additionalProperties = dataFields.filter((property) => property.additional);
		additionalProperties.forEach((property) => {
			this.additional_info[property.name] = property.required === false ? null : "";
		});
	}

	setVisitPointInfo(newVisitPoint) {
		this.visit_point_id = newVisitPoint.id;
		this.cx = newVisitPoint.cx;
		this.cy = newVisitPoint.cy;
		this.city = newVisitPoint.city;
		this.address = newVisitPoint.address;
	}

	/**
	 * retorna un array de objetos que contiene informacion de los campos dinamicos que se renderizan
	 * en el formulario de puntos de puntos de visita
	 * @param {*} tipology objeto que copntien la tipologia de donde se obtienen las propiedades adicionales
	 */
	dataModelEventDinamicFields(category) {
		const dataFields = category.json_properties.filter((element) => element.additional);
		if (this.id === 0) {
			this.setAddtionalInfo(dataFields);
		}
		return dataFields.map((element) => {
			return {...element, error: false};
		});
	}

	/**
	 * retorna un objeto con la informacion de los campos requeridos para la creacion de un evento
	 * return object
	 */
	getDataToSave() {
		const data = {
			activity_id: this.activity_id,
			init_date: this.init_date,
			end_date: this.end_date,
			init_hour: this.init_hour,
			end_hour: this.end_hour,
			repeat: this.repeat,
			resource_id: this.resource_id,
			visit_point_id: this.visit_point_id,
			additional_info: this.additional_info,
			event_status_id: this.event_status_id,
		};
		return data;
	}

	// get data unless resoruce_id
	getDataToSaveOnDemand() {
		const data = {
			activity_id: this.activity_id,
			init_date: this.init_date,
			end_date: this.end_date,
			init_hour: this.init_hour,
			end_hour: this.end_hour,
			repeat: this.repeat,
			visit_point_id: this.visit_point_id,
			additional_info: this.additional_info,
		};
		return data;
	}

	getDataToUpdate() {
		const data = {
			date_prog: this.date_prog,
			init_hour: this.init_hour,
			end_hour: this.end_hour,
			resource_id: this.resource_id,
			visit_point_id: this.visit_point_id,
			additional_info: this.additional_info,
			event_id: this.id,
		};
		return data;
	}

	fullAddress() {
		return `${this.address} ${this.city} `;
	}

	coordinates() {
		return `${this.cy},${this.cx}`;
	}
}
